<div class="section_header">
  <div class="section_header_title">
    <h2>Pedidos de publicidade</h2>
  </div>
</div>

<div class="filters" *ngIf="Origin != 'miArea'">
  <div class="row">
    <div class="col-md-3 mb-3">
      <select2 id="distribOrder" [value]="defaultDistrib" [(ngModel)]="defaultDistrib" [data]="distributorsList" class="select2"></select2>
    </div>
    <div class="col-auto mb-3"><button class="btn-search" (click)="rerender()">Filtro</button></div>
  </div>
</div>

<div *ngIf="Origin != 'miArea'" class="row mb-4">
  <div class="col-md-6">
    <button type="button" (click)="DownloadExcelValla()" class="btn-orange-border btn-icon">
      <div class="svg-icon"><svg viewBox="0 0 150 150">
          <use xlink:href="assets/images/icons/ico_download_auto.svg#img" href="assets/images/icons/ico_download_auto.svg#img"></use>
        </svg>
      </div>
      DOWNLOAD PEDIDO DE OUTDOOR
    </button>
  </div>
  <!-- <div class="col-6">
    <button type="button" (click)="DownloadExcelCatalogo()" class="btn-orange-border btn-icon">
      <div class="svg-icon"><svg viewBox="0 0 150 150">
          <use xlink:href="assets/images/icons/ico_download_auto.svg#img" href="assets/images/icons/ico_download_auto.svg#img"></use>
        </svg>
      </div>
      DESCARGAR PEDIDOS DE CATÁLOGO
    </button>
    </div> -->
</div>
<h5>Lista de pedidos</h5>
<div class="table-responsive-lg fadein-table">
  <table id="tblEvaluation" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table data-tables dataTable condensed-table no-footer">
    <thead>
      <tr>
        <th class="w-8 text-center">Código </th>
        <th class="w-12">Concessionário</th>
        <th class="w-20">Utilizador</th>
        <th class="w-8 text-center">Pedido</th>
        <th class="w-8 text-center">Data</th>
        <th class="text-center">Campanhas</th>
        <th class="text-center">Materiais</th>
        <th class="w-8 text-center">Opções</th>
      </tr>
    </thead>
  </table>
</div>